import React from 'react';
import { motion } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'; // أضف هذا الاستيراد
import { toggleLanguage } from '../../redux/slices/languageSlice';
import { logout } from '../../redux/slices/authSlice';
import './Header.css';

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // أضف هذا السطر
  const { currentLanguage, direction } = useSelector((state) => state.language);
  const { isAuthenticated } = useSelector((state) => state.auth);
  
  const navItems = [
    { id: 'home', label: { en: 'Home', ar: 'الرئيسية' } },
    { id: 'services', label: { en: 'Services', ar: 'الخدمات' } },
    { id: 'about', label: { en: 'About', ar: 'عن الشركة' } },
    { id: 'contact', label: { en: 'Contact', ar: 'تواصل معنا' } },
  ];
  
//   const scrollToSection = (sectionId) => {
//     if (sectionId === 'services') {
//       navigate('/services');
//       return;
//     }
    
//     if (sectionId === 'home') {
//       navigate('/');
//       return;
//     }
const scrollToSection = (sectionId) => {
  if (sectionId === 'home') {
    navigate('/');
         return;

  } else if (sectionId === 'services') {
    navigate('/services');
         return;

  } else if (sectionId === 'about') {
    navigate('/about');
         return;

  } else if (sectionId === 'contact') {
    navigate('/contact');
     return;
  }

    
    // إذا كنا في الصفحة الرئيسية، استخدم التمرير
    if (window.location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // إذا كنا في صفحة أخرى، اذهب للصفحة الرئيسية ثم قم بالتمرير
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };
  
  return (
    <motion.header 
      className="header"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container header-container">
        <div className="logo">
          <motion.div 
            className="logo-container"
            whileHover={{ scale: 1.05 }}
          >
            <img 
              src="/images/Sandlogo.png" 
              alt="سند للتأمين - SANAD Insurance"
              className="logo-image"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='150' height='50' viewBox='0 0 150 50'%3E%3Crect width='150' height='50' fill='%236d28d9' rx='8'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' font-family='Arial' font-size='16' fill='white'%3Eسند للتأمين%3C/text%3E%3C/svg%3E";
              }}
            />
          </motion.div>
        </div>
        
        <nav className={`nav ${direction === 'rtl' ? 'rtl' : 'ltr'}`}>
          <ul className="nav-list">
            {navItems.map((item) => (
              <li key={item.id} className="nav-item">
                <motion.button
                  className="nav-link"
                  onClick={() => scrollToSection(item.id)}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {item.label[currentLanguage]}
                </motion.button>
              </li>
            ))}
          </ul>
        </nav>
        
        {/* <div className="header-actions">
          <motion.button
            className="language-toggle"
            onClick={() => dispatch(toggleLanguage())}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            {currentLanguage === 'en' ? 'العربية' : 'English'}
          </motion.button>
          
          {isAuthenticated ? (
            <motion.button
              className="logout-btn"
              onClick={() => dispatch(logout())}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {currentLanguage === 'en' ? 'Logout' : 'تسجيل خروج'}
            </motion.button>
          ) : null}
      
      
        </div> */}
      </div>
    </motion.header>
  );
};

export default Header;